import React from "react";
import { IStep } from "../../../../interfaces/sw/SWInterfaces";
import useSelector from "../../../../store/useSelector";

const SWStepNotices: React.FC<IStep> = (step) => {
    const { swStepNoticeData } = useSelector(store => store.manageSW);
    const stepNotices = swStepNoticeData.swStepNotices?.filter(x => x.stepId === step.id);
    const hasTaskNotices = stepNotices === undefined ? false : stepNotices.length > 0 ? true : false;
    const hasSteporSubStepNotices = hasStepNotices(step.children);
    function hasStepNotices(steps: IStep[]): boolean | undefined {
        let isNoticePresent = false;
        for (let i = 0; i < steps.length; i++) {
            const notices = swStepNoticeData.swStepNotices?.filter(x => x.stepId === steps[i].id);
            if (notices !== undefined && notices.length > 0) {
                isNoticePresent = true;
                return isNoticePresent;
            }
            else {
                if (steps[i].children.length > 0) {
                    isNoticePresent = hasStepNotices(steps[i].children) ?? false;
                }
            }
        }
        return isNoticePresent;
    }

    const parseHTML = (htmlString: string | undefined): React.ReactNode[] => {

        if (!!!htmlString) {
            return [htmlString];
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const container = doc.body || doc;
        const elements: React.ReactNode[] = [];

        if (!container.childNodes.length) {
            return [htmlString];
        }

        container.childNodes.forEach((node, index) => {
            if (node.nodeType === Node.TEXT_NODE) {
                elements.push(node.textContent);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node as Element;
                if (element.tagName === "A") {
                    elements.push(
                        <a key={index} href={element.getAttribute("href") || "#"} target="_blank" rel="noopener noreferrer">
                            {element.textContent}
                        </a>
                    );
                }
            }
        });

        return elements;
    };

    return (
        <div className="step-notices">
            {(hasTaskNotices || hasSteporSubStepNotices) &&
                <ul>
                    <li>
                        <div>
                            <div className="title">
                                <label>{step.title}</label>
                            </div>
                            <div className="notice-list">
                                <ul>{hasTaskNotices &&
                                    stepNotices?.map((notice, index) => (
                                        <li key={index}>{parseHTML(notice.label?.replace(/<\/?p>/g, ''))}</li>
                                    ))}
                                    {hasSteporSubStepNotices &&
                                        step.children
                                            .map((item, index) => (
                                                <SWStepNotices key={index.toString()} {...item} />
                                            ))}
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            }
        </div>)
}

export default SWStepNotices;